var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErgonomie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1073,
    height: 605,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1072.18 0L43.248 3.604c-137.352 242.896 92.68 306.089 134.23 338.225C251.396 399 305.906 478.888 310.896 604.5l761.284-.121V0z",
    fill: "#078DBE",
    fillOpacity: 0.8
  })));
}

export default __webpack_public_path__ + "9a414d43d0298d2448517a3ef682a5ba.svg";
export { SvgErgonomie as ReactComponent };